module.exports = "//static.hsappstatic.net/marketplace-unified-public-ui/static-1.4018/img/screenshot-twitter.png"